module.exports = __webpack_public_path__ + "media/images/athletes/4148-c6bd644dbe5accdfd76effad467e8c54.png";